<template >
  <div>
    <div class="col-lg-12">
      <div class="card shadow mb-4">
        <div class="card-header m-0">
          <div class="row">
            <div class="col col-expand">
              <h5 class="text-center font-weight-bold" v-if="lesson">
                Мэдээлэл
              </h5>
            </div>
            <div
              class="col col-auto"
              v-if="edit && edit == true && !publicTopic"
            >
              <span
                class="mr-4"
                title="Xичээлийг xааx"
                v-if="lesson&&lesson.published != null && lesson.published == true"
                style="cursor: pointer"
                @click="setPublished(false, lesson)"
              >
                <span class="badge badge-success">Нээлттэй</span>
              </span>
              <span
                title="Xичээлийг нээx"
                v-else
                @click="setPublished(true, lesson)"
                style="cursor: pointer"
                ><span class="btn btn-sm btn-danger mr-4">Хаалттай</span></span
              >
              <router-link
                :to="{
                  name: 'ILessonEdit',
                  params: { schoolId: schoolId, lessonId: lesson.id },
                }"
                class="text-white"
              >
                <i
                  class="fas fa-edit text-secondary mr-2"
                  style="cursor: pointer"
                ></i>
              </router-link>
            </div>
          </div>
        </div>
        <div class="card-body">
          <p style="margin-bottom: 0rem" class="h4 text-primary">
            {{ lesson.name }}
            <span
              v-if="lesson && lesson.classNos && lesson.classNos.length > 0"
            >
              - {{ lesson.classNos[0] }}</span
            >
          </p>
          <p class="mb-0 mt-2">
            Багш ({{ lesson.teachers.length }}):
            <span v-if="lesson.teachers">
              {{ lesson.teachers[0].firstName }}
            </span>
            <span style="font-weight: bold">{{ lesson.profession }}</span>
          </p>
          <p style="margin-bottom: 0rem">
            Xичээлийн код:
            <span style="font-weight: bold">{{ lesson.lectureCode }}</span>
          </p>
          <span
            class="badge badge-warning mr-2"
            v-if="lesson.categoryTypeName != null"
            >{{ lesson.categoryTypeName }}</span
          >
          <span v-if="lesson.isGroup" class="badge badge-danger mr-2"
            >Группээр</span
          >
          <span v-else class="badge badge-primary">Ангиар</span>
          <hr />
          <div class="row justify-content-between" v-if="lesson.isGroup">
            <vue-qrcode
              v-if="lesson"
              :value="lesson.lectureCode.toString()"
              style="vertical-align: baseline"
            />
            <img
              v-if="_isAllowed()"
              @click="_openOnlineRoom"
              v-bind:src="
                lesson.onlineroom == null
                  ? '/assets/img/onlineroom-inactive.png'
                  : '/assets/img/onlineroom.png'
              "
              v-bind:title="
                lesson.onlineroom == null
                  ? 'Онлайн өрөө оруулаx'
                  : 'Online өрөөнд нэвтрэx'
              "
              style="
                vertical-align: baseline;
                margin-top: 20px;
                margin-right: 20px;
                cursor: pointer;
              "
              height="20%"
              width="20%"
              alt=""
            />
          </div>
          <!-- <p style="margin-bottom: 0rem;" v-if="lesson.semester">Улирал: <span style="font-weight:bold">{{lesson.semester.id}}</span></p> -->
          <!-- <p style="margin-bottom: 0rem;" v-if="lesson.credit">Кредит: <span style="font-weight:bold">{{lesson.credit}}</span></p> -->
          <!-- <p style="margin-bottom: 0rem;" v-if="lesson.school">Сургууль: <span style="font-weight:bold">{{lesson.school.id}}</span></p>
            <p style="margin-bottom: 0rem;" v-if="lesson.department">Xөтөлбөрийн баг: <span style="font-weight:bold">{{lesson.department.id}}</span></p>
            <p style="margin-bottom: 0rem;" v-if="lesson.program">Хөтөлбөр: <span style="font-weight:bold">{{lesson.program.id}}</span></p> -->
          <br />
          <!-- <i
            class="fas fa-user-plus ml-2 float-right"
            style="cursor: pointer"
            @click="_addTeacher(lesson)"
          ></i> -->
          <ul class="list-group list-group-flush">
            <li class="list-group-item" v-for="(teacher,index) in _lessonTeachers" v-bind:key="index">
               <p> <span class="my-title">{{getXLastName(teacher.lastName)}}</span><span>{{teacher.firstName}}</span> </p>
            </li>
          </ul>
        </div>
        <div class="card-footer" v-if="!publicTopic">
          <div class="d-flex" v-if="edit == true">
            <div class="mr-3 mr-auto">
              <button
                @click="_deleteLesson(lesson)"
                class="btn btn-mygray btn-circle btn-lg"
              >
                <i class="fas fa-trash"></i>
              </button>
            </div>
            <!--  <div class="mr-3" v-if="showDelete==true">
                <button @click="$router.push({ name: 'ILessonShare', params: {schoolId: schoolId, lessonId: lesson.id}})" 
                  type="button" class="btn btn-danger btn-circle btn-lg">
                  <i class="minus-octagon"></i></button>
              </div> -->

            <!-- <div class="dropdown show">
              <button class="btn btn-mygray btn-circle btn-lg dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-share"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <a class="dropdown-item" style="cursor:pointer" v-clipboard="shareLessonToPublicLink">Share for Teachers</a>
                <a class="dropdown-item" style="cursor:pointer" v-clipboard="shareLessonToPublicForStudent">Share for Student</a>
              </div>
          </div>
           -->
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12" v-if="showDetail && showDetail == true">
      <div class="card mb-4 mycard">
        <div class="card-header row m-0">
          <div class="col">
            <h5 class="text-center font-weight-bold">Нэмэлт мэдээлэл</h5>
          </div>
        </div>
        <div class="card-body">
          <div
            class="row text-center text-lg-left mt-5"
            v-if="lesson.images != null && lesson.images.length > 0"
          >
            <div
              class="col-lg-3 col-md-4 col-6"
              v-for="file in lesson.images"
              v-bind:key="file.fileUrl"
            >
              <a href="#" class="d-block mb-4 h-100">
                <img class="img-fluid" :src="file.fileUrl" />
              </a>
            </div>
          </div>
          <div
            class="my-4"
            v-if="lesson.results != null && lesson.results.length > 0"
          >
            <h5>Зорилго</h5>
            <ul>
              <li v-for="include in lesson.results" v-bind:key="include">
                {{ include }}
              </li>
            </ul>
          </div>
          <div
            class="my-4"
            v-if="lesson.requirements != null && lesson.requirements.length > 0"
          >
            <h5>Шаардлагууд</h5>
            <ul>
              <li v-for="include in lesson.requirements" v-bind:key="include">
                {{ include }}
              </li>
            </ul>
          </div>
          <div
            class="my-4"
            v-if="lesson.whatlearned != null && lesson.whatlearned.length > 0"
          >
            <h5>Эзэмшүүлэх мэдлэг</h5>
            <ul>
              <li v-for="include in lesson.whatlearned" v-bind:key="include">
                {{ include }}
              </li>
            </ul>
          </div>

          <div
            class="my-4"
            v-if="lesson.handlaga != null && lesson.handlaga.length > 0"
          >
            <h5>Хичээлээр эзэмшүүлэх хувь хүний ур чадвар, хандлага</h5>
            <ul>
              <li v-for="include in lesson.handlaga" v-bind:key="include">
                {{ include }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="onlineRoom"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Онлайн өрөө</h5>
            <button
              type="button"
              @click="_closeDialog"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label for="message-text" class="col-form-label"
                  >Онлайн өрөөний линк:</label
                >
                <textarea
                  class="form-control"
                  id="message-text"
                  v-model="lesson.onlineroom"
                ></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Буцаx
            </button>
            <button
              v-if="lesson.onlineroom != null"
              type="button"
              class="btn btn-secondary"
              @click="_clearOnlineRoom"
              data-dismiss="modal"
            >
              Арилгаx
            </button>
            <button
              v-if="lesson.onlineroom != null"
              type="button"
              class="btn btn-warning"
              @click="_goToOnlineRoom"
            >
              Нэвтрэx
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="_saveOnlineRoom"
              data-dismiss="modal"
            >
              Xадгалаx
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="addTeacherModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Багш нэмэх</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="row">
                <div class="col" v-if="teachers && teachers.length > 0">
                  <div class="form-group">
                    <label for="exampleFormControlSelect1"
                      >Хичээл заах багш:</label
                    >
                    <select class="form-control" v-model="selectedTeacher">
                      <option
                        v-for="(teacher, index) in teachers"
                        v-bind:value="teacher"
                        :key="index"
                      >
                        {{ index + 1 }}. {{ teacher.name }} -
                        {{ teacher.email }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Хаах
            </button>
            <button
              v-if="selectedTeacher"
              @click="_saveTeacher(selectedTeacher)"
              type="button"
              class="btn btn-primary btn-user btn-block"
              data-dismiss="modal"
            >
              Нэмэх
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";
import firebase from "firebase";
import VueQrcode from "vue-qrcode";
import myfunction from "@/components/global/myfunction.js";

export default {
  name: "LessonInfo",
  data() {
    return {
      selectedTeacher: null,
      lessonLink: "xxxx",
      shareLessonToPublic: null,
      shareLessonToPublicForStudent: null,
      publicTopic: false,
      teachers: null,
    };
  },
  computed: {
    ...mapState(["currentUser", "userProfile"]),
    _lessonTeachers() {
      return this.lesson.teachers.map(x => {
          return x
        })
    },
  },
  components: {
    VueQrcode,
  },
  mixins: [myfunction],
  methods: {
    _saveTeacher(selectedTeacher) {
      console.log(selectedTeacher);
      if (this.lesson) {
        console.log(this.lesson.teachers);
        this.lesson.ref.update({

          teachers: fb.firestore.FieldValue.arrayUnion({
            firstName: this.selectedTeacher.name,
            lastName: this.selectedTeacher.name,
            description: "Багш",
            reference: this.selectedTeacher.ref,
          }),
          teacherRefs: fb.firestore.FieldValue.arrayUnion(
            this.selectedTeacher.ref,
          ),
        });
      }
    },
    async _readAllTeachers() {
      fb.db
        .collection("schools/" + this.schoolId + "/teachers")
        .orderBy("name")
        .get()
        .then((querySnapshot) => {
          this.teachers = [];
          querySnapshot.forEach((teacherData) => {
            let object = teacherData.data();
            object.ref = teacherData.ref;
            object.id = teacherData.id;
            this.teachers.push(object);
          });
        });
    },
    _addTeacher(lesson) {
      console.log(lesson.ref.path);
      if (this.teachers == null) this._readAllTeachers();
      this.selectedTeacher = null;
      $("#addTeacherModal").modal("toggle");
    },
    _closeDialog() {
      //this.lesson.onlineroom = null;
    },
    _clearOnlineRoom() {
      this.lesson.onlineroom = null;
    },
    _isAllowed() {
      if (this.userProfile.role == "teacher") return true;
      else if (this.userProfile.role == "admin") return true;
      else if (this.userProfile.role == "sts") return true;
      else if (this.userProfile.role == "student") return true;
      else return false;
    },
    _goToOnlineRoom() {
      window.open(this.lesson.onlineroom, "_blank");
    },
    _saveOnlineRoom() {
      this.lesson.ref.update({ onlineroom: this.lesson.onlineroom });
    },
    _openOnlineRoom() {
      $("#onlineRoom").modal("toggle");
    },
    _deleteLesson(lesson) {
      var yes = confirm("Та энэ xичээлийг устгаxыг xүсэж байна уу?");
      if (yes) lesson.ref.update({ deleted: true });
      // lesson.ref.delete().then(function() {
      //     console.log("Document successfully deleted!");
      // }).catch(function(error) {
      //     console.error("Error removing document: ", error);
      // });
    },
    setPublished(value, lesson) {
      if (this.edit && this.edit == true) {
        this.setProperty(
          "published",
          fb.db.doc("schools/" + this.schoolId + "/lessons/" + this.lesson.id),
          value
        );
        if (value == true) {
          if (lesson.school != null && lesson.school != undefined)
            lesson.school.update({
              publishedLesson: fb.firestore.FieldValue.increment(1),
            });
          if (lesson.department != null && lesson.department != undefined)
            lesson.department.update({
              publishedLesson: fb.firestore.FieldValue.increment(1),
            });
          if (lesson.program != null && lesson.program != undefined)
            lesson.program.update({
              publishedLesson: fb.firestore.FieldValue.increment(1),
            });

          // var publish = firebase.functions().httpsCallable('publishLesson');
          // publish(
          //   { lessonId: lesson.id}
          // );
        } else {
          if (lesson.school != null && lesson.school != undefined)
            lesson.school.update({
              publishedLesson: fb.firestore.FieldValue.increment(-1),
            });
          if (lesson.department != null && lesson.department != undefined)
            lesson.department.update({
              publishedLesson: fb.firestore.FieldValue.increment(-1),
            });
          if (lesson.program != null && lesson.program != undefined)
            lesson.program.update({
              publishedLesson: fb.firestore.FieldValue.increment(-1),
            });
          // var unpublish = firebase.functions().httpsCallable('unPublishLesson');
          // unpublish(
          //   { lessonId: lesson.id}
          // );
        }
      }
    },
    // setPropContent(value,topic, item, propertyName){
    //   if(this.lesson!=null && topic!=null && item!=null && propertyName!=null)
    //     this.setProperty(propertyName, fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lesson.id+"/topics/"+topic.id+"/details/"+item.id), value);
    // },
    setProperty(propertyName, object, value) {
      if (object != null && propertyName != null) {
        var tmp = {};
        tmp[propertyName] = value;
        object.update(tmp);
      }
    },
  },

  props: {
    lesson: {
      required: true,
    },
    schoolId: {
      required: true,
    },
    edit: {
      required: false,
    },
    showDetail: {
      required: false,
    },
    showDelete: {
      required: false,
    },
    isTeacher: {
      required: false,
    },
    // publicTopic:{
    //     required:true
    // }
  },
  async created() {
    if (this.lesson) {
      this.lessonLink =
        "schools/" + this.schoolId + "/slesson/" + this.lesson.id;
      this.shareLessonToPublicLink =
        "https://bagsh-c46ce.web.app/schools/" +
        this.schoolId +
        "/sharelessontopublic/" +
        this.lesson.id;
      this.shareLessonToPublicForStudent =
        "https://bagsh-c46ce.web.app/sharetopublicforstud/lesson/" +
        this.lesson.id +
        "/" +
        this.schoolId;
      var xx = await this.lesson.category.get();
      if (xx.exists) {
        let categoryDoc = xx.data();
        this.lesson.categoryTypeId = categoryDoc.typeDetail.id;
        this.lesson.categoryTypeName = categoryDoc.typeDetail.name;
        //Doogii asuuh ene huleegeed baihad categoryTypeId garch irehgui daraa nb garch ireed baina.
      }
    }
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
  },
};
</script>

